<div class="forbidden__container">
    <h1>Forbidden</h1>
    <span>You have no access to this resource.</span>
    <button [ax-button]="'primary'" [routerLink]="'/'">Back to home</button>
</div>